module.exports = __webpack_public_path__ + "img/Versatility.113d31df.svg";